import { IConstants } from '#/CoreFrameInterfaces';

export default {
    CALL_ENVELOPE_CLIENT_ACTION_STRING: 'CALL_ENVELOPE_CLIENT_ACTION_STRING',
    CALL_ENVELOPE_SELECT_OBJECT_IN_LV_ACTION_STRING: 'CALL_ENVELOPE_SELECT_OBJECT_IN_LV_ACTION_STRING',
    CALL_ENVELOPE_CONTEXT_NEEDS_REFRESH: 'CALL_ENVELOPE_CONTEXT_NEEDS_REFRESH',
    CALL_ENVELOPE_DV_FORCE_CLOSING_ACTION: 'CALL_ENVELOPE_DV_FORCE_CLOSING_ACTION',
    CALL_ENVELOPE_DV_FORCE_APPLY_ACTION: 'CALL_ENVELOPE_DV_FORCE_APPLY_ACTION',
    CALL_ENVELOPE_OPEN_WEBPAGE: 'CALL_ENVELOPE_OPEN_WEBPAGE',
    CALL_ENVELOPE_DV_STACK_TYPENAME: 'CALL_ENVELOPE_DV_STACK_TYPENAME',
    CALL_ENVELOPE_DV_STACK_PDO: 'CALL_ENVELOPE_DV_STACK_PDO',
    CALL_ENVELOPE_DV_ACTION_CLOSE: 'CALL_ENVELOPE_DV_ACTION_CLOSE',
    CALL_ENVELOPE_SHOW_RESULT_IN_GUI: 'CALL_ENVELOPE_SHOW_RESULT_IN_GUI',
    CALL_ENVELOPE_DV_HAS_OBJECT_CHANGED: 'CALL_ENVELOPE_DV_HAS_OBJECT_CHANGED',
    CALL_ENVELOPE_DV_LEAVING_ACTION: 'CALL_ENVELOPE_DV_LEAVING_ACTION',
    CALL_ENVELOPE_DV_HAS_PENDING_DVC: 'CALL_ENVELOPE_DV_HAS_PENDING_DVC',
    HISTORISIERUNG_SUCCESS: 'HISTORISIERUNG_SUCCESS',
    SEARCH_HISTORY_DATE_ALL: 'SEARCH_HISTORY_DATE_ALL',
    TOOLBAR_SAVE_BUTTON: 'TOOLBAR_SAVE',
    TOOLBAR_APPLY_BUTTON: 'TOOLBAR_APPLY',
    TOOLBAR_CANCEL_BUTTON: 'TOOLBAR_CANCEL'
} as IConstants;